
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(75894|91618)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
